import { BulkOperationType } from './bulk-operation-type';

export class BulkOperationRequest {
  operationType: BulkOperationType;
  entityList: string[];
  subscriptionType: string;
}
